<template>
  <a-modal
      title="选择职称名称"
      :visible="visible"
      @ok="handleOk"
      :maskClosable="false"
      @cancel="handleCancel"
      :confirm-loading="confirmLoading"
      :width="1300">
    <div class="mb-2">
      已选择职称：
      <a-button-group v-if="item.selectedValue" size="small" class="ml-2 mb-2" v-for="(item) in professionalTitleList">
        <a-button>{{ item.selectedName }}</a-button>
        <a-button @click="removeMethod(item)" type="danger">
          <a-icon type="delete"></a-icon>
        </a-button>
      </a-button-group>
    </div>
    <a-row type="flex" :gutter="12">
      <a-col :span="6">
        <div class="zdy_ul_box">
          <ul class="zdy_ul">
            <li :class="item.active?'active':''" v-for="item in professionalTitleList">
              <span @click="onSelectChange(item)">{{ item.name }}</span>
              <a-icon type="right"/>
            </li>
          </ul>
        </div>
      </a-col>
      <a-col :span="11">
        <div class="zdy_ul_box">
          <ul class="zdy_ul" style="text-align: center;padding-top: 30%;">
            <a-radio-group :value="professionalTitleItemList.selectedValue">
              <a-radio v-for="item2 in professionalTitleItemList.items"
                       @click="onCheckedChange($event,professionalTitleItemList,item2)"
                       :value="professionalTitleItemList.value+'/'+item2.value">{{ item2.name }}
              </a-radio>
            </a-radio-group>
          </ul>
        </div>
      </a-col>
      <a-col :span="7">
        <div class="zdy_ul_box"  style="text-align: center;padding-top: 30%;">
          <div style="padding:10px 6px;text-align: center;color:#000;font-size:16px">在左侧分类中没有找到?<br>手工输入其他职称</div>
          <a-textarea v-model="otherSpecificProfessionalTitle" style="width:90%;margin: 0 5% 0 5%"
                      placeholder="字数限制:50个字以内" :maxLength="maxLength"
                      :auto-size="{ minRows: 3, maxRows: 3 }"/>
        </div>
      </a-col>
    </a-row>
  </a-modal>

</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import { GetProfessionalTitleList } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'

export default {
  name: 'ChooseExpertProfessionalTitle',
  components: {
    PageView,
    STable
  },
  mounted () {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      confirmLoading: false,
      professionalTitleList: [],//职称列表
      professionalTitleItemList: {},//具体职称列表
      otherSpecificProfessionalTitle: undefined,//具体职称列表
      maxLength: 50,
    }
  },
  created () {
  },
  watch: {
    visible (val) {
      if (val) {
        this.professionalTitleItemList = {}
      }
    }
  },
  methods: {
    //数据回显
    async preView (json, otherSpecificProfessionalTitle) {
      this.otherSpecificProfessionalTitle = otherSpecificProfessionalTitle
      await this.getProfessionalTitleList(json)
    },
    //确认后数据传回调用方
    handleOk () {
      let userSelectContent = this.professionalTitleList.filter(item => item.selectedName)
      this.$emit('success', userSelectContent, this.otherSpecificProfessionalTitle)
    },
    //关闭窗口
    handleCancel () {
      this.$emit('cancel')
    },
    //获取职称数据
    async getProfessionalTitleList (json) {
      try {
        let res = await GetProfessionalTitleList()
        if (200 === res.code) {
          res.result && res.result.forEach(item => {
            item.selectedName = undefined
            item.selectedValue = undefined
            item.active = false
          })
          this.professionalTitleList = res.result
          if (json && json.length > 0) {
            json.forEach(item => {
              let data = this.professionalTitleList.filter(item2 => item.value.includes(item2.value))[0]
              if (data) {
                data.selectedName = item.name
                data.selectedValue = item.value
              }
            })
          }
        }
      } catch (e) {
        this.$message.error(e.message)
      } finally {
      }
    },
    //处理单选框选中状态
    onCheckedChange (event, item, item2) {
      let data = this.professionalTitleList.filter(item3 => item.id === item3.id)[0]
      if (data) {
        data.selectedName = item.name + '/' + item2.name
        data.selectedValue = item.value + '/' + item2.value
      }
      item.selectedName = item.name + '/' + item2.name
      item.selectedValue = item.value + '/' + item2.value
    },
    //处理文字选中状态
    async onSelectChange (item) {
      this.professionalTitleList.map(item2 => {
        item2.active = item2.id === item.id
      })
      //获取选中的数据
      this.professionalTitleItemList = { ...item }
    },
    removeMethod (data) {
      data.selectedValue = undefined
      data.selectedName = undefined
      if (data.id === this.professionalTitleItemList.id) {
        this.professionalTitleItemList = { ...data }
      }
    },
  }
}
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 24px;
}

/deep/ .ant-empty {
  margin: 90px 8px;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}

.close-span:hover {
  cursor: pointer;
}
</style>
